import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { type LinkProps } from "~/common/components/Link";
import { forwardRef } from "react";
import { PreferredIndicator } from "~/domains/product/components/PreferredIndicator";
import { Designation } from "~/domains/product/components/Designation";
import { styled, Box } from "~/common/mui";
import classNames from "classnames";

interface Props extends BaseProductElementProps {
  component?: keyof JSX.IntrinsicElements;
  designationComponent?: keyof JSX.IntrinsicElements;
  clickable?: boolean;
  linkProps?: LinkProps;
  truncate?: boolean;
}

const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== "truncate",
})<{ truncate?: boolean }>(({ truncate }) => ({
  display: "flex",
  alignItems: "center",
  ...(truncate && {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "& > .truncate": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& a": {
      display: "inline",
    },
  }),
}));

export const FullDesignation = forwardRef<HTMLElement, Props>((props, ref) => {
  const { component: rootComponent, designationComponent, truncate, ...rest } = props;
  const RootComponent = rootComponent ?? "div";

  if (truncate) {
    rest.className = classNames(rest.className, "truncate");
  }

  return (
    <Root as={RootComponent} className={props.className} truncate={truncate} ref={ref}>
      <PreferredIndicator product={rest.product} />
      <Designation as={designationComponent} {...rest} />
    </Root>
  );
});
